import React, { lazy, Suspense } from 'react';
import type { DailyTimeReportTableProps } from './DailyTimeReportTable';
const LazyDailyTimeReportTable = lazy(async () => await import ('./DailyTimeReportTable'));

const DailyTimeReportTable = (props: DailyTimeReportTableProps) => (
  <Suspense fallback={null}>
    <LazyDailyTimeReportTable { ...props} />
  </Suspense>
);

export default DailyTimeReportTable;
